module.exports = __webpack_public_path__ + "marie.png?814c87d33d68afcb58f6d87b25394161";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marie.png
// module id = 166
// module chunks = 0